import { RegionsEnum } from '../enums/RegionsEnum';

export const getDiscontinued = (region: RegionsEnum): string => {
    switch (region) {
        case RegionsEnum.am: {
            return '470';
        }
        case RegionsEnum.ap: {
            return '472';
        }
        case RegionsEnum.eu:
        default: {
            return '474';
        }
    }
};
